module.exports = __webpack_public_path__ + "static/2-006e46dd36207af70f927ff754dc5d92.svg";